import { customerSurveyClient } from "@core/clients";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { SupaCustomerSurveyCompletionsType } from "../../4time/src/shared/types/supabaseFragments";

type Options = UseMutationOptions<void, unknown, Omit<SupaCustomerSurveyCompletionsType, "id" | "created_at">, string[]>;

const useCreateCustomerSurveyAnswers = (options?: Options) => {
  return useMutation(
    ["customer-survey/create"],
    async (payload) => {
      if (customerSurveyClient) {
        return customerSurveyClient.createCustomerSurveyAnswers(payload);
      }
      throw new Error("customerSurveyClient not implemented");
    },
    {
      ...options,
    }
  );
};

export default useCreateCustomerSurveyAnswers;
